import { Link, useParams } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { MdxBody } from "@/components/MdxBody";
import { bySlug, papers } from "@/lib/content/load";
import { headingText } from "@/lib/heading";
import { NotFoundPage } from "./NotFoundPage";

export function PaperDetailPage() {
  const { slug = "" } = useParams();
  const record = bySlug(papers, slug);
  if (!record) return <NotFoundPage />;
  const { meta, Component } = record;

  return (
    <>
      <Seo
        title={meta.title}
        description={meta.seoDescription}
        path={meta.canonicalPath}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "ScholarlyArticle",
          name: meta.title,
          author: meta.authors.map((name) => ({ "@type": "Person", name })),
          datePublished: String(meta.year),
          url: meta.recordUrl,
        }}
      />
      <article className="wrap section" style={{ paddingTop: "4.5rem" }}>
        <p className="eyebrow">Research · {meta.year}</p>
        <h1>{headingText(meta.title)}</h1>
        <p className="lede">{meta.summary}</p>
        <p>
          <strong>Citation.</strong> {meta.citation}
        </p>
        <p>
          <a href={meta.recordUrl}>Full record</a>
        </p>
        <MdxBody Component={Component} />
        <p>
          <Link to="/resources#research">All resources</Link>
        </p>
      </article>
    </>
  );
}
